<template>
  <ai-carousel-card-only
    id="Carousel_Sport_Fitness_Activities"
    v-model="currentStep"
    access-id="SportFitnessActivitiesCarousel"
    :items="items"
    :title="$t('hotel.sportAndFitnessActivities.title')"
    :gutter="gutter"
    :slide-width="slideWidth"
    :component="AiCardLearnMore"
    mobile-button
    :aria-label="
      $t('accessibility.description.hotelSportAndFitnessActivitiesCarousel')
    " />
</template>

<script setup lang="ts">
import type { HotelSportActivityFragment } from '~~/domains/graphql';
import AiCardLearnMore from '~~/domains/ux/molecules/AiCard/AiCardLearnMore.vue';

interface Props {
  cards: HotelSportActivityFragment[];
}

const props = defineProps<Props>();
const isSmallDevice = useMatchMediaQuery('tablet');
const isDesktopDevice = useMatchMediaQuery('large-desktop');

const gutter = computed(() => {
  if (isSmallDevice.value) return 16;

  return isDesktopDevice.value ? 64 : 32;
});
const slideWidth = computed(() => (isSmallDevice.value ? 0.9 : 0.333));

const currentStep = ref<number>(1);

const items = computed(() =>
  props.cards.map(item => ({
    description: item.introduction,
    label: item.goldSticker?.label,
    learnMoreUrl: item.learnMoreUrl,
    picture: item.picto,
    title: item.title,
    titleCapitalized: true,
    lazyLoadImage: true,
  })),
);
</script>
